import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebService } from '../web/web.service';

@Injectable({
  providedIn: 'root',
})
export class StorageWebService {
  constructor(private readonly _webService: WebService) {}

  public getStorageData(idUtente: string): Observable<any> {
    return this._webService.doGet('/api/v1/dashboard/utente/' + idUtente + '/chart-storage', {});
  }
  public getUpdatedStorageData(idUtente: string): Observable<any> {
    return this._webService.doGet(
      '/api/v1/dashboard/utente/' + idUtente + '/update-chart-storage',
      {},
    );
  }
}
